import api from './api';

export const submitClaim = (data) => api.post('/api/membership/claim', data);
export const getMyClaim = (tenantId) => api.get('/api/membership/claims/my', { params: { tenantId } });
export const getClaims = (params) => api.get('/api/membership/claims', { params });
export const reviewClaim = (id, data) => api.put(`/api/membership/claims/${id}/review`, data);
export const getVerificationHistory = (params) => api.get('/api/membership/verifications', { params });
export const getMemberships = (params) => api.get('/api/membership', { params });
export const changeMemberRole = (membershipId, communityRole) =>
  api.patch(`/api/membership/${membershipId}/role`, { communityRole });
export const addMember = (data) => api.post('/api/membership/members', data);
export const updateStaffSections = (membershipId, staffSections) =>
  api.patch(`/api/membership/${membershipId}/staff-sections`, { staffSections });
